import { SectionKey } from '../../../../../types';
import { FormState } from '../../types';

export const createSectionEditGate = (
  assignedSections: unknown,
  sectionKey: SectionKey
): boolean =>
  Array.isArray(assignedSections) &&
  assignedSections.some(
    (assignedSection: unknown) => assignedSection === sectionKey
  );

export const createStandardDisabledState = (
  formState: Pick<FormState, 'data' | 'completedSections'>,
  sectionKey: SectionKey
): boolean => {
  const isEditAllowed = createSectionEditGate(
    formState.data?.userAssignedSections,
    sectionKey
  );
  const isSectionComplete =
    formState.completedSections?.includes(sectionKey) || false;

  return isSectionComplete || !isEditAllowed;
};
